import React from 'react';
import { IconChartL } from '../../icons';
import css from './StatisticsSectionActions.css';
import classNames from 'classnames';

const ActionWrapper = ({ children, rootClassName = null }) => (
    <div className={classNames(css.actionRoot, rootClassName)}>
        <IconChartL />
        <p className={css.actionContent}>
            {children}
            , <br /> um Statistiken einzusehen.
        </p>
    </div>
);

export default ActionWrapper;
